const Dash = () => import("./Dash.vue");
import Layout from "../../Internal/Layout.vue";
// const Dashboard = () => import("./Dashboard/Dashboard.vue");

const DashRoutes = {
  component: Layout,
  children: [
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dash,
      meta: {
        requiresMaster: true,
        requiresAdmin: true,
        requiresMarketing: true,
        requiresAuth: true,
        requiresManagerial: true,
        requiresFinancial: true,
      },
    },
  ],
};

export default DashRoutes;
